module.exports = __webpack_public_path__ + "static/img/2.b54cad6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/productBanner/woman/product/2.jpg
// module id = YMCJ
// module chunks = 0